const getSiteTypeAllowWithTypes = (types) => {
	return types.join(',')
}

const getFetchSiteTypeAllowWithTypes = (types) => {
	const tmp = getSiteTypeAllowWithTypes(types)
	return '{' + tmp + '}'
}
const getFetchSiteIds = (siteIds) => {
	return '{' + siteIds.join(',') + '}'
}

const getDefaultMapCenter = (user = undefined) => {
	const defaultX = 2.5048828125
	const defaultY = 46.649436163350245
	const defaultReturn = [defaultX, defaultY]
	if (user) {
		if (user.latitude && user.longitude) {
			return [Number(user.latitude), Number(user.longitude)]
		}
		return defaultReturn
	}
	return defaultReturn
}
const getDefaultZoom = (user = undefined) => {
	return user.zoom ? Number(user.zoom) : 7
}

export { getFetchSiteTypeAllowWithTypes, getSiteTypeAllowWithTypes, getFetchSiteIds, getDefaultMapCenter, getDefaultZoom }



// WEBPACK FOOTER //
// ./src/utils/ApplicationUtils.js